<ng-container *ngIf="loaded; else loading">
    <div class="involved-party" *ngIf="!showEmptyResult">
        <div class="involved-party__header">
            <p>Hier kunt u de gegevens invullen van andere mensen die betrokken waren.</p>
        </div>
        <div class="involved-part__container">
            <ng-container *ngFor="let party of involvedParties$ | async">
                <ins-party
                    (closed)="onClose()"
                    (opened)="onOpen($event)"
                    *ngIf="party.toevoegen_toestaan || party.personen.length > 0"
                    [fileSerialNumber]="file_serial_number"
                    [party]="party"
                    [relationId]="relation_id"
                    [showContent]="this.open === party.rol"
                    class="involved-party__content"
                ></ins-party>
            </ng-container>
        </div>
        <cyno-alert
            *ngIf="notifications"
            [customClass]="'alert-error--invert'"
            [meldingen]="notifications"
        ></cyno-alert>
    </div>

    <div *ngIf="showEmptyResult" class="involved-party">
        <div class="involved-party__empty">
            <p>De map is leeg, omdat deze informatie voor uw claim niet nodig is.</p>
        </div>
    </div>
</ng-container>

<ng-template #loading>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line skeleton-loader__line--half no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line skeleton-loader__line--half no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
</ng-template>
